import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { UserIcon, SettingsIcon, SunIcon, MoonIcon } from 'lucide-react';
interface HeaderProps {
  isConnected: boolean;
  onConnectionToggle: () => void;
  onOpenSettings: () => void;
}
export const Header: React.FC<HeaderProps> = ({
  isConnected,
  onConnectionToggle,
  onOpenSettings
}) => {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <header className="bg-white dark:bg-gray-800 shadow-sm py-2 px-4" data-id="element-63">
      <div className="flex items-center justify-between" data-id="element-64">
        <div className="flex items-center" data-id="element-65">
          <h1 className="text-xl font-bold text-blue-600 dark:text-blue-400" data-id="element-66">
            PathoPlex32
          </h1>
        </div>
        <div className="flex items-center space-x-2" data-id="element-67">
          <div className={`px-2 py-1 rounded-full text-xs flex items-center cursor-pointer ${isConnected ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'}`} onClick={onConnectionToggle} data-id="element-68">
            <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${isConnected ? 'bg-green-500' : 'bg-red-500'}`} data-id="element-69"></span>
            {isConnected ? 'Connected' : 'Disconnected'}
          </div>
          <button onClick={toggleTheme} className="p-1.5 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700" aria-label="Toggle theme" data-id="element-70">
            {theme === 'light' ? <MoonIcon size={16} data-id="element-71" /> : <SunIcon size={16} data-id="element-72" />}
          </button>
          <button onClick={onOpenSettings} className="p-1.5 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700" aria-label="Settings" data-id="element-73">
            <SettingsIcon size={16} data-id="element-74" />
          </button>
          <button className="p-1.5 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700" aria-label="User profile" data-id="element-75">
            <UserIcon size={16} data-id="element-76" />
          </button>
        </div>
      </div>
    </header>;
};